// import $ from "jquery";

import "./themes/components/_autoload";
import "./themes/glossary/_autoload";
import "./themes/gform/_autoload";
import "./themes/utils/_autoload";
import "./themes/searchfilter/_autoload";

